export default __webpack_public_path__ + "assets/images/c2ef0b8420e53f30979144529df48193.png";